import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import Backdrop from '../../shared/Backdrop';
import './Login.css';
import LoginPage1 from './LoginPage1';
import LoginPage2 from './LoginPage2';
import LoginPage3 from './LoginPage3';

const ModalOverlay = props => {
  const [page, setPage] = useState(1);
  const mobileNumberRef = useRef(null);
  const remainingTimeRef = useRef(null);

  const content = (
    <div ref={props.nodeRef} className="login-modal rounded rtl  ">
      <header className="login-modal__header rounded text-dark ">

        <h4 className="font-weight-bold">
          <span>ورود / ثبت نام</span>
          <i className="fa fa-user-circle me-2 " style={{color:'#aaa'}}></i>
        </h4>
      </header>
      <div>
        <div className="login-modal__content">
        {page && page === 1 && (
          <LoginPage1
            setPage={setPage}
            mobileNumberRef={mobileNumberRef}
            remainingTimeRef={remainingTimeRef}
          />
        )}
        {page && page === 2 && (
          <LoginPage2
            setPage={setPage}
            mobileNumberRef={mobileNumberRef}
            remainingTimeRef={remainingTimeRef}
            closeLoginModal = {props.onCancel}
          />
        )}
        {page && page === 3 && (
          <LoginPage3
            setPage={setPage}
            mobileNumberRef={mobileNumberRef}
            closeLoginModal = {props.onCancel}
          />
        )}
        </div>
        <footer className="login-modal__footer">
        </footer>
      </div>
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById('login-modal-hook'));
};

const Login = props => {
  const nodeRef = useRef(null);
  return (
    <React.Fragment>
      {props.show && <Backdrop onClick={props.onCancel} bgLighter />}
      <CSSTransition
        nodeRef={nodeRef}
        in={props.show}
        mountOnEnter
        unmountOnExit
        timeout={500}
        classNames="login-modal"
      >
        <ModalOverlay nodeRef={nodeRef} {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default Login;
